import {
    applyMiddleware,
    createStore
} from 'redux';
import thunk from 'redux-thunk';
import { defaultState } from './initialState';
import reducerFn from "./reducer";

const store = () => {
    const storeValue = createStore(reducerFn, defaultState, applyMiddleware(thunk));
    return storeValue
};
export default store